import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { VTableModule } from "@app/directives/_layout/v-table/v-table.module";
import { MapDirectivesModule } from "@app/directives/_map/_map.directives.module";
import { ResourceFiltersDirectivesModule } from "@app/directives/_resourceFilters/_resourceFilters.directives.module";
import { ResourceManagementModule } from "@app/main/components/resourceManagement/resourceManagement.module";
import { CameraModule } from "@app/main/modules/cameras/camera.module";
import { P100DeviceDetails } from "@app/main/modules/foundation/_routes/hardware/peripherals/p100-device-details/p100-device-details.component";
import { StreamaxDeviceDetail } from "@app/main/modules/foundation/_routes/hardware/peripherals/streamax-device-details/streamax-device-details.component";
import { CoreDirectivesModule } from "@directives/_core/_core.directives.module";
import { FormsDirectivesModule } from "@directives/_forms/_form.directives.module";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { VehicleDirectivesModule } from "../../../../../directives/_vehicle/_vehicle.directives.module";
import { FoundationComponentsModule } from "../../_components/components.modules";
import { CommissionModule } from "../commissions/commission.module";
import { CameraEventsComponent } from "./peripherals/camera-events/camera-events.component";
import { CameraLogsComponent } from "./peripherals/camera-logs/camera-logs.component";
import { CameraVideoViewComponent } from "./peripherals/camera-videos/camera-videos-view/camera-video-view.component";
import { CameraVideosComponent } from "./peripherals/camera-videos/camera-videos.component";
import { CameraViewComponent } from "./peripherals/camera-view/camera-view.component";
import { GpsDetailComponent } from "./peripherals/gps-detail/gps-detail.component";
import { PeripheralDeviceDetails } from "./peripherals/peripheral-device-details/peripheral-device-details.component";
import { PeripheralListComponent } from "./peripherals/peripheral-list/peripheral-list.component";
import { PeripheralViewComponent } from "./peripherals/peripheral-view/peripheral-view.component";
import { PulseMessageDetailComponent } from "./peripherals/pulse/pulse-message-detail/pulse-message-detail.component";
import { PulseMessagesComponent } from "./peripherals/pulse/pulse-messages.component";
import { PulseResponseComponent } from "./peripherals/pulse/pulse-response/pulse-response.component";
import { SimDetailComponent } from "./sim/sim-detail/sim-detail.component";
import { SimListComponent } from "./sim/sim-list/sim-list.component";
import { SimUnitSummaryComponent } from "./sim/sim-unit-summary/sim-unit-summary.component";
import { UnitListComponent } from "./units/unit-list/unit-list.component";
import { UnitLogsComponent } from "./units/unit-logs/unit-logs.component";
import { UnitOverviewComponent } from "./units/unit-view/unit-overview/unit-overview.component";
import { UnitPlotsComponent } from "./units/unit-view/unit-plots/unit-plots.component";
import { UnitViewComponent } from "./units/unit-view/unit-view.component";
import { StreamaxConfigsModule } from "../streamax-configs/streamax-configs.module";

const privateComponents: any[] = [
];

const publicComponents: any[] = [
    UnitListComponent,
    PeripheralListComponent,
    UnitViewComponent,
    PeripheralViewComponent,
    CameraViewComponent,
    UnitOverviewComponent,
    UnitLogsComponent,
    UnitPlotsComponent,
    SimUnitSummaryComponent,
    PeripheralDeviceDetails,
    PulseMessagesComponent,
    PulseMessageDetailComponent,
    PulseResponseComponent,
    StreamaxDeviceDetail, 
    P100DeviceDetails,
    CameraLogsComponent,
    CameraEventsComponent,
    GpsDetailComponent,
    SimListComponent,
    SimDetailComponent,
    CameraVideosComponent,
    CameraVideoViewComponent
];

const declarations: any[] = [
];

const providers: any[] = [

];

@NgModule({
    imports: [
        CommonModule,
        PipesModule,
        FormsModule,
        FormsDirectivesModule,
        ReactiveFormsModule,
        VeriDirectivesModule,
        VehicleDirectivesModule,
        MiscDirectivesModule,
        LayoutDirectivesModule,
        CoreDirectivesModule,
        VTableModule,
        ResourceFiltersDirectivesModule,
        ResourceManagementModule,
        FoundationComponentsModule,
        MapDirectivesModule,
        CommissionModule,
        CameraModule,
        StreamaxConfigsModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class HardwareModule {
    constructor() {
    }
}
